<template>
  <div
    class="pagination__wrapper"
    v-if="initPages > 1"
  >
    <div
      v-if="pageNum > 1"
      class="pagination__prev"
      @click="prevPage()"
    >
      <icon name="arrow_left_solid"></icon>Prev
    </div>
    <div class="pagination__list">
      <span
        class="pagination__list__number"
        v-for="page in initPages"
        :key="page"
        @click="goToPage(page)"
        :class="{ active : pageNum === page}"
      >
        {{ page }}
      </span>
    </div>
    <div
      v-if="pageNum !== initPages"
      class="pagination__next"
      @click="nextPage()"
    >
      Next<icon name="arrow_right_solid"></icon>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/scripts/components/basic/Icon.vue';
import VButton from '@/scripts/components/buttons/VButton.vue';

export default {
  name: 'SearchResultsPaginationControls',
  components: { Icon, VButton },
  props: {
    initPages: {
      type: Number,
      required: true,
    },
    bottomPagination: {
      type: Boolean,
      default: false,
    },
    paginationAmount: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      pageNavActive: false,
      pageNum: this.currentPage
    };
  },
  computed: {
    numShowing() {
      return Math.min(
        this.paginationAmount * this.currentPage,
        this.currentTotal
      );
    },
    progressPercentStyle() {
      return { width: `${(this.numShowing / this.currentTotal) * 100}%` };
    },
    pages() {
      if (this.currentTotal < this.paginationAmount) {
        return 1;
      } else {
        return this.initPages;
      }
    }
  },
  methods: {
    goToPage(pageNum) {
      this.pageNum = pageNum;
      this.$emit('go-to-page', pageNum);
    },
    nextPage() {
      if (this.pageNum < this.initPages) {
        this.pageNum++;
        this.$emit('go-to-page', this.pageNum);
      }
    },
    prevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.$emit('go-to-page', this.pageNum);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.collection-pagination-controls {
  display: flex;
  align-items: center;
  user-select: none;

  .collection-load-more {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__progress {
      position: relative;
      width: 312px;
      height: 3px;
      background-color: $color-lightest-grey;
      margin-bottom: 20px;
      @include mobile-only {
        width: 300px;
      }
    }

    &__progress-total {
      position: absolute;
      background-color: $color-black;
      display: block;
      left: 0;
      top: 0;
      height: 3px;
      width: 0;
    }

    &__showing {
      margin-bottom: 24px;
    }
  }

  // spinner
  .spinner {
    width: 40px;
    height: 40px;

    position: relative;
    margin: 0 auto;
  }

  .double-bounce1,
  .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $color-light-grey;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2s infinite ease-in-out;
    animation: sk-bounce 2s infinite ease-in-out;
  }

  .double-bounce2 {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  @-webkit-keyframes sk-bounce {
    0%,
    100% {
      -webkit-transform: scale(0);
    }
    50% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bounce {
    0%,
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    50% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }
}

.pagination {
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__prev,
  &__next {
    font-family: $font-family-primary;
    color: $color-black-900;
    line-height: 51px;
    display: flex;
    cursor: pointer;

    .icon {
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  &__list {
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    &__number {
      float: left;
      text-decoration: none;
      width: 51px;
      height: 51px;
      line-height: 51px;
      border-radius: 51px;
      margin-left: 9px;
      margin-right: 9px;
      text-align: center;
      cursor: pointer;
      &.active {
        border: 1px solid $color-black-700;
      }
    }
  }
}
</style>
